import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { HeaderComponent } from './header/header.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { AppNavItemComponent } from './sidebar/nav-item/nav-item.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ModalRedefinirSenhaModule } from 'src/app/shared/components/modal-redefinir-senha/modal-redefinir-senha.module';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PerfilEnum } from 'src/app/shared/enums/perfil.enum';
import { MatDialog } from '@angular/material/dialog';
import { ModalSejaProComponent } from 'src/app/shared/components/modal-seja-pro/modal-seja-pro.component';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    TablerIconsModule,
    HeaderComponent,
    AppBreadcrumbComponent,
    ModalRedefinirSenhaModule,
  ],
  templateUrl: './full.component.html',
  styleUrls: [],
})
export class FullComponent implements OnInit {

  @ViewChild('leftsidenav')
  public sidenav!: MatSidenav;

  //get options from service
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  showWhastapp = false;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  constructor(private breakpointObserver: BreakpointObserver, private authService: AuthService, public dialog: MatDialog, private router: Router) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes

        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];

        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
      });
    this.showWhastapp = !!(this.authService.usuarioPerfil === PerfilEnum.RESTAURANTE);

  }

  async ngOnInit() {
    if (this.authService.usuarioPerfil === PerfilEnum.RESTAURANTE && this.authService.planoPro !== 'true') {
      if(this.authService.getPlanoPreSelecionado !== 'null' && this.authService.getPlanoPreSelecionado !== 'Plano Free') {
        await this.router.navigate([`/meu-plano/${this.authService.getPlanoPreSelecionado}`])
      }else{
        // const dialogRef = await this.dialog.open(ModalSejaProComponent, {
        // });
        // dialogRef.afterClosed().subscribe(async (resultado) => {
        //   if (resultado.redirecionar) {
        //     await this.router.navigate(['/meu-plano']);
        //   }
        // });
      }
    }
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
  }
}
